const Error = ({ error }: { error: string }) => {
  return <div className="border-red bg-red/60 rounded-2xl border p-4 text-white">{error}</div>
}

export default Error
